"use client";

import { motion } from "framer-motion";

const labels = [
  { text: "Lead arrives", x: "8%", y: "43%", className: "" },
  { text: "Routing", x: "33%", y: "27%", className: "hidden md:block" },
  { text: "Follow-up", x: "46%", y: "31%", className: "hidden md:block" },
  { text: "Handoffs", x: "58%", y: "35%", className: "hidden md:block" },
  { text: "Reporting", x: "70%", y: "38%", className: "hidden md:block" },
  { text: "Ownership", x: "76%", y: "41%", className: "hidden lg:block whitespace-nowrap" },
  { text: "Revenue recorded", x: "79%", y: "50%", className: "whitespace-nowrap" },
] as const;

const columns = ["34%", "47%", "60%", "73%", "86%"] as const;

export default function LeadFlowScene() {
  return (
    <div className="signal-hero relative overflow-hidden rounded-[32px]">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_55%_50%,rgba(56,189,248,0.10),transparent_16%),linear-gradient(145deg,rgba(7,14,26,0.32),rgba(4,9,17,0.08))]" />

      {columns.map((left) => (
        <div key={left} className="signal-column" style={{ left }} aria-hidden="true" />
      ))}

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55, ease: "easeOut" }}
        className="signal-curve"
        aria-hidden="true"
      >
        <svg viewBox="0 0 960 560" fill="none" preserveAspectRatio="none">
          <path d="M122 284C245 284 284 284 348 284C438 284 498 282 574 294C650 306 724 308 836 308" stroke="rgba(125, 211, 252, 0.9)" strokeWidth="4" strokeLinecap="round" />
          <path d="M132 284C244 282 302 274 354 250C432 214 500 204 564 214" stroke="rgba(56, 189, 248, 0.18)" strokeWidth="2" strokeLinecap="round" />
          <path d="M132 284C238 286 290 294 346 320C408 348 478 360 560 354" stroke="rgba(56, 189, 248, 0.16)" strokeWidth="2" strokeLinecap="round" />
          <path d="M132 284C222 282 270 258 308 232C348 204 402 176 478 178" stroke="rgba(56, 189, 248, 0.12)" strokeWidth="2" strokeLinecap="round" />
          <path d="M132 284C222 288 272 316 312 344C356 376 410 398 486 396" stroke="rgba(56, 189, 248, 0.12)" strokeWidth="2" strokeLinecap="round" />
          <path d="M132 284C232 286 278 302 336 332C394 362 456 376 524 374" stroke="rgba(56, 189, 248, 0.1)" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scaleX: 0.92 }}
        animate={{ opacity: 1, scaleX: 1 }}
        transition={{ duration: 0.9, ease: "easeOut", delay: 0.12 }}
        className="signal-glow left-[16%] top-[48.5%] w-[50%]"
        aria-hidden="true"
      />

      <div className="signal-node left-[8.9%] top-[47.2%]" aria-hidden="true" />
      <div className="signal-node left-[58.5%] top-[45.6%]" aria-hidden="true" />
      <div className="signal-node left-[85.7%] top-[48.8%]" aria-hidden="true" />

      {labels.map((label) => (
        <p
          key={label.text}
          className={`signal-label text-[9px] sm:text-[11px] ${label.className}`}
          style={{ left: label.x, top: label.y }}
        >
          {label.text}
        </p>
      ))}
    </div>
  );
}
